(function ($) {
  $('#admSliderWrapper').slick({
    arrows: false,
    dots: false,
    fade: true,
    autoplay: true
  });
})(jQuery);